<div [class.three-column-layout]="easyLanguageStyleVisible"
     [class.two-column-layout]="!easyLanguageStyleVisible">
    <app-tile
            [cdkTrapFocus]="isAudioMode"
            [cdkTrapFocusAutoCapture]="isAudioMode"
            [tabindex]="1"
            [contentFromTop]="true"
            [title]="'ONBOARDING.LANGUAGE_STYLE.STANDARD_TITLE' | translate"
            [text]="'ONBOARDING.LANGUAGE_STYLE.STANDARD_DESCRIPTION' | translate"
            [ariaLabel]="('ONBOARDING.LANGUAGE_STYLE.STANDARD_TITLE' | translate) + ('GENERAL.BUTTON' | translate)"
            (tileClickEvent)="nextStepClick(languageStyleStandard)">
    </app-tile>
    <app-tile
            [tabindex]="2"
            [disabled]="false"
            [contentFromTop]="true"
            [title]="'ONBOARDING.LANGUAGE_STYLE.SIMPLE_TITLE' | translate"
            [text]="'ONBOARDING.LANGUAGE_STYLE.SIMPLE_DESCRIPTION' | translate"
            [ariaLabel]="('ONBOARDING.LANGUAGE_STYLE.SIMPLE_TITLE' | translate) + ('GENERAL.BUTTON' | translate)"
            (tileClickEvent)="nextStepClick(languageStyleSimple)">
    </app-tile>
    <app-tile *ngIf="easyLanguageStyleVisible"
              [tabindex]="3"
              [disabled]="false"
              [contentFromTop]="true"
              [title]="'ONBOARDING.LANGUAGE_STYLE.EASY_TITLE' | translate"
              [ariaLabel]="('ONBOARDING.LANGUAGE_STYLE.EASY_TITLE' | translate) + ('GENERAL.BUTTON' | translate)"
              (tileClickEvent)="nextStepClick(languageStyleEasy)">
        <ng-container list>
            <p class="tile__text">{{'ONBOARDING.LANGUAGE_STYLE.EASY_LANGUAGE' | translate}}</p>
            <ul class="list">
                <li class="list__item">{{'ONBOARDING.LANGUAGE_STYLE.EASY_WORDS' | translate}}</li>
                <li class="list__item">{{'ONBOARDING.LANGUAGE_STYLE.EASY_SHORT' | translate}}</li>
                <li class="list__item">{{'ONBOARDING.LANGUAGE_STYLE.EASY_PARAGRAPHS' | translate}}</li>
            </ul>
            <p class="tile__text">{{'ONBOARDING.LANGUAGE_STYLE.EASY_DISABILITIES' | translate}}</p>
            <ul class="list">
                <li class="list__item">{{'ONBOARDING.LANGUAGE_STYLE.EASY_READING' | translate}}</li>
                <li class="list__item">{{'ONBOARDING.LANGUAGE_STYLE.EASY_LEARNING' | translate}}</li>
                <li class="list__item">{{'ONBOARDING.LANGUAGE_STYLE.EASY_OLD' | translate}}</li>
            </ul>
        </ng-container>
    </app-tile>
</div>
